import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';

@Component({
  selector: 'app-show-more',
  templateUrl: './show-more.component.html',
  styleUrls: ['./show-more.component.scss']
})
export class ShowMoreComponent implements OnInit {
  @Input() dataSource?: any;
  @Input() showExportAsCsv?= true;
  @Input() exportAsCsvLocal?= false;
  @Input() fileName: string;
  @Output() optionSelection = new EventEmitter;

  constructor() { }

  ngOnInit() {
  }

  public exportAsCSV(event: Event) {
    const filename = this.generateFileName();
    if (!this.exportAsCsvLocal) {
        // tslint:disable-next-line:no-unused-expression
        new Angular2Csv(this.dataSource, filename, { headers: Object.keys(this.dataSource[0]) });
    } else {
        this.selectedOption({ text: 'csv', value: 'csv' });
    }
  }

  private generateFileName() {
    // ToDo Reduce the code using moment js
    const date = new Date();
    const dateformat = [
        date.getFullYear().toString(),
        ('0' + (date.getMonth() + 1)).slice(-2),
        ('0' + date.getDate()).slice(-2)
    ].join('') + '-' +
        [('0' + date.getHours()).slice(-2),
        ('0' + date.getMinutes()).slice(-2),
        ('0' + date.getSeconds()).slice(-2)].join('');
    return this.fileName + '-' + dateformat;
  }

  public selectedOption(option) {
    this.optionSelection.emit(option);
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/show-more/show-more.component.ts